import React from 'react'

const MARGIN = 15

const ObjectRenderer=props=>{
  const {value,margin,className} = props
  if (typeof(value)==='string'&&value.length>0) {
    return <div className="ant-list-item-meta-description">{value}</div>
  }
  if (Array.isArray(value)&&value.length>0) {
    const m = (()=>{
      if (typeof(margin)==='number') {
        return margin+MARGIN
      }
      return MARGIN
    })()
    const style = {
      marginLeft: margin||0,
    }
    return (
      <div className={`ant-list ${className||''}`} style={style}>
        {
          value.map((e,i)=>(
            <ObjectRenderer key={i} value={e} margin={m} />
          ))
        }
      </div>
    )
  }
  if (typeof(value)==='object'&&value!==null) {
    const keys = Object.keys(value)
    const m = margin||0
    const style = {
      marginLeft: m,
    }
    if (Array.isArray(keys)&&keys.length>0) {
      return (
        <div className={`ant-list ${className}`} style={style}>
          {
            keys.map((e,i)=>(
              <div key={i} className="ant-list-item">
                <div className="ant-list-item-meta">
                  <div className="ant-list-item-meta-content">
                    <h4 className="ant-list-item-meta-title">{e}</h4>
                    <ObjectRenderer value={value[e]} className="ml-3" />
                  </div>
                </div>
              </div>
            ))
          }
        </div>
      )
    }
  }
  return (
    <div><pre><code>{JSON.stringify(value,null,2)}</code></pre></div>
  )
}

export default ObjectRenderer
